/**
 * 通貨ストア
 * Comspostion API で記述すること
 */
"use strict";

import axiosBase, { all } from "axios";
import { AxiosError } from "axios";
import { defineStore } from "pinia";
import { ref, inject } from "vue";
import { useStorage } from "@vueuse/core";
import { useEnvStore } from "../store/env-store";
import { AXIOS_KEY } from "@/utils/constants";

//import { useAxiosStore } from "../store/axios-store";
// import {
//   StatisticsData,
//   CurData,
//   CurMaster,
//   TwoPairStatisticsData,
//   TwoPairOptimazedData,
// } from "../types/defs";

export const useUserStore = defineStore("userStore", () => {
  const isLoggedIn = ref(false);
  const notificationPermit = ref("");
  const axios = inject(AXIOS_KEY);
  if (axios === undefined) {
    throw new Error("axios is undefined");
  }

  const $env = useEnvStore();
  /**
   * ユーザ情報の取得
   * @returns ユーザ情報
   */
  const getUserInfo = async () => {
    try {
      //const $axios = useAxiosStore().axios;
      const res = await axios.get(`user/info`);
      // TODO:エラー処理
      console.log(res);

      isLoggedIn.value = true;

      return res;
    } catch (err) {
      console.log("err", err);
      isLoggedIn.value = false;
    }
  };
  /**
   * ログイン
   */
  const login = async () => {
    if ($env.isDev) {
      location.href = "http://localhost:8080/cage/user/login";
    } else {
      location.href = "/cage/user/login";
    }
  };
  /**
   * ログアウト
   */
  const logout = async () => {
    if ($env.isDev) {
      location.href = "http://localhost:8080/cage/user/logout";
    } else {
      location.href = "/cage/user/logout";
    }
  };
  /**
   * 通知を許可状況を取得
   */
  const checkAllowNotification = () => {
    notificationPermit.value = Notification.permission;
    console.log("通知許可状況:", notificationPermit.value);
  };
  /**
   * 通知を許可するか確認する
   * ※一度選択したらブラウザの設定からしか変更できない
   */
  const confirmAllowNotification = async () => {
    Notification.requestPermission(async function (status) {
      console.log("通知の許可:", status); //コンソールに許可されたかどうかを表示
      notificationPermit.value = status;
      if (status === "granted") {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
          alert("このブラウザはプッシュ通知をサポートしていません");
          return;
        }
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey:
            "BNAi80S3XRssaJE_A3wHqbEq0d2S-9LFsNE1JEojLdQm0TFMLWHwfHU2dyvjfheRX_vAv9gbxVrQ_3Hh4J9NCZM",
        });

        await fetch("api/subscribe/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(subscription),
        });

        alert("プッシュ通知が有効になりました！");
      }
    });
  };
  return {
    getUserInfo,
    isLoggedIn,
    login,
    logout,
    checkAllowNotification,
    notificationPermit,
    confirmAllowNotification,
  };
});
